import { Card, Space } from 'antd';
import React from 'react';
import PendingCard from './PendingCard';
import ChatsEnabler from './ChatsEnabler';
import ExpertiseCard from './ExpertiseCard';
import InactivityCard from './InactivityCard';
import CommunityProfile from './CommunityProfile';

interface PartnerNode {
  name: any;
  id: string;
}

interface CategoryNode {
  id: string;
}

interface Moment {
  url: string;
  id: string;
}

interface Category {
  node: CategoryNode
}

interface PendingExpertPartner {
  node: PartnerNode;
  bucket: string | null;
  isEnabled: boolean;
  bio: string | null;
  moments: Moment[];
  categories: Category[];
  roles: string[];
}

interface ExpertPartner {
  bucket: string | null;
  node: PartnerNode;
}

interface JoinedCardsProps {
  partner: ExpertPartner | PendingExpertPartner;
}

const JoinedCards = function ({ partner }: JoinedCardsProps) {
  const {
    bucket,
    node: {
      name,
      id: partnerId,
    },
  } = partner;

  const isPartnerEnabled = ('isEnabled' in partner
    && partner.isEnabled) ?? false;

  return (
    <>
      {bucket && !['inactive', 'pending'].includes(bucket)
        && (
          <>
            <Card>
              <Space direction="vertical" style={{ width: '100%' }} size={18}>
                <ChatsEnabler
                  partnerId={partnerId}
                  name={name.en}
                  isEnabled={isPartnerEnabled}
                />
                <CommunityProfile
                  partnerId={partnerId}
                  bio={('bio' in partner && partner.bio) || null}
                  name={name.en}
                  moments={('moments' in partner && partner.moments) || []}
                />
              </Space>
            </Card>
            <ExpertiseCard
              categories={('categories' in partner && partner.categories) || []}
              partnerId={partnerId}
              isEnabled={isPartnerEnabled}
            />
          </>
        )}
      {bucket === 'inactive' && (
        <InactivityCard
          partnerId={partnerId}
          name={name.en}
          roles={('roles' in partner && partner.roles) || []}
        />
      )}
      {bucket === 'pending' && (
        <PendingCard partnerId={partnerId} />
      )}
    </>
  );
};

export default JoinedCards;
